import { stringSearch, useSetSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { PartDetailsTabContent } from '@/areas/parts/PartDetailsPage/components/PartDetailsTabController';
import { canViewPartLibrarySourcing } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/parts/details/$partId/offers')({
    staticData: { access: { permissions: canViewPartLibrarySourcing }, chrome: 'home' } satisfies PageStaticData,
    validateSearch: stringSearch({ taskId: 'optional' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const { partId } = Route.useParams();
    const requiredQuantity = Route.useSearch({ select: (search) => search.requiredQuantity });
    const setSearch = useSetSearch();
    return (
        <PartDetailsTabContent
            tab={'offers'}
            partId={partId}
            pricingSearch={{ requiredQuantity, onSearchChange: setSearch }}
        />
    );
}
